import React from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Uploder from "../Uploader";
import { sortsDatas } from "../Datas";
import { Button, DatePickerComp, Input, Select } from "../Form";
import { BiChevronDown } from "react-icons/bi";
import { toast } from "react-hot-toast";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { RiDeleteBin5Line } from "react-icons/ri";
import DatePicker from "react-datepicker";
import { BaseUrl } from "../../BaseUrl";

function PersonalInfo({ titles }) {
  const navigate = useNavigate();
  const [title, setTitle] = React.useState(sortsDatas.title[0]);
  const [date, setDate] = React.useState(new Date());
  const [gender, setGender] = React.useState(sortsDatas.genderFilter[0]);
  
  // Form state
  const [fullName, setFullName] = React.useState("");
  const [uhid, setUhid] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [aadharId, setAadharId] = React.useState("");
  const [bloodGroup, setBloodGroup] = React.useState(sortsDatas.bloodTypeFilter?.[0] || { id: 1, name: "Select Blood Group" });
  const [emergencyContact, setEmergencyContact] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [referredBy, setReferredBy] = React.useState("");
  
  // Doctor dropdown state
  const [selectedDoctor, setSelectedDoctor] = React.useState(null);
  const [doctorsList, setDoctorsList] = React.useState([]);
  const [loadingDoctors, setLoadingDoctors] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  
  // Fetch doctors/professionals on component mount
  React.useEffect(() => {
    fetchDoctors();
  }, []);
  
  const fetchDoctors = async () => {
    try {
      setLoadingDoctors(true);
      const response = await axios.get(`${BaseUrl}/facility/getAllProfessionalUsers`, {
        withCredentials: true,
      });
      
      if (response.data.success && response.data.data) {
        // Transform professionals to Select component format with "Dr." prefix
        const transformedDoctors = response.data.data.map((user, index) => {
          const fullName = user.fullName || "Unknown";
          const displayName = user.category === "Doctor" || user.subCategory === "Doctor" 
            ? `Dr. ${fullName}` 
            : fullName;
          
          return {
            id: user._id || index + 1,
            _id: user._id,
            name: displayName,
            fullName: fullName,
            emailId: user.emailId,
            mobileNumber: user.mobileNumber,
          };
        });
        
        // Add a default "Select Doctor" option
        const defaultOption = { id: 0, name: "Select Doctor", _id: null };
        setDoctorsList([defaultOption, ...transformedDoctors]);
        setSelectedDoctor(defaultOption);
      } else {
        toast.error("Failed to fetch doctors");
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
      toast.error(error.response?.data?.message || "Error loading doctors");
    } finally {
      setLoadingDoctors(false);
    }
  };
  
  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    // Validation
    if (!fullName.trim()) {
      toast.error("Full Name is required");
      return;
    }
    
    if (!phoneNumber.trim()) {
      toast.error("Phone Number is required");
      return;
    }
    
    if (!selectedDoctor || selectedDoctor._id === null) {
      toast.error("Please select a doctor");
      return;
    }
    
    try {
      setSubmitting(true);
      
      // Calculate age from date of birth
      const age = date ? Math.floor((new Date() - new Date(date)) / (365.25 * 24 * 60 * 60 * 1000)) : null;
      
      // Prepare patient data
      const patientData = {
        fullName: fullName.trim(),
        mobileNumber: phoneNumber.trim(),
        email: email.trim() || undefined,
        uhid: uhid.trim() || undefined,
        aadharId: aadharId.trim() || undefined,
        gender: gender?.name && gender.name !== "All" && gender.name !== "Gender..." ? gender.name : undefined,
        dateOfBirth: date || undefined,
        age: age || undefined,
        bloodGroup: bloodGroup?.name && bloodGroup.name !== "Blood Type..." ? bloodGroup.name : undefined,
        address: address.trim() || undefined,
        contactDetails: {
          primaryContact: phoneNumber.trim(),
          email: email.trim() || undefined,
          emergencyContact: emergencyContact.trim() || undefined,
        },
        referredBy: referredBy.trim() || undefined,
        doctorId: selectedDoctor._id, // Send selected doctor ID
      };
      
      // Remove undefined fields
      Object.keys(patientData).forEach(key => {
        if (patientData[key] === undefined) {
          delete patientData[key];
        }
      });
      
      const response = await axios.post(
        `${BaseUrl}/doctor/patients/create`,
        patientData,
        {
          withCredentials: true,
        }
      );
      
      if (response.data.success) {
        toast.success("Patient added successfully!");
        // Navigate back to patients list immediately
        navigate("/patients");
      } else {
        toast.error(response.data.message || "Failed to add patient");
      }
    } catch (error) {
      console.error("Error adding patient:", error);
      toast.error(
        error.response?.data?.message || 
        error.response?.data?.error || 
        "Failed to add patient. Please try again."
      );
    } finally {
      setSubmitting(false);
    }
  };
  
  const handleCancel = () => {
    navigate("/patients");
  };
  return (
    <form onSubmit={handleSubmit}>
      <div className='group mt-3 flex w-[60%] flex-row items-center justify-between rounded-lg border border-border bg-dry p-4 focus-within:border focus-within:border-[#0095D9]'>
        <img
          src={require("../../Assets/images/search.png")}
          className='mr-2 h-6 w-6'
        />
        <input
          type='text'
          placeholder='Search'
          className='font-md w-full bg-transparent text-sm text-black focus:outline-none'
        />
      </div>
      <div className='mt-4 grid items-end gap-4 md:grid-cols-2'>
        {/* select  */}
        {titles && (
          <div className='flex w-full flex-col gap-3'>
            <p className='text-sm text-black'>Title</p>
            <Select
              selectedPerson={title}
              setSelectedPerson={setTitle}
              datas={sortsDatas.title}
            >
              <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                {title?.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>
        )}

        {/* UHI ID */}
        {/* <div className='mt-3 w-[90%] text-sm'>
          <div className='flex w-full flex-row items-center justify-between'>
            <label className={"text-sm text-black"}>UHI ID</label>
            <div className='rounded-sm bg-[#0095D9] p-2'>
              <span className={"text-sm text-white"}>Generate</span>
            </div>
          </div>
          <div className='group mt-3 flex flex-row items-center justify-between rounded-lg border p-3 focus-within:border focus-within:border-[#0095D9]'>
            <input
              type='text'
              placeholder='Enter Health Id'
              value={uhid}
              onChange={(e) => setUhid(e.target.value)}
              className='w-full bg-transparent text-sm font-light focus:outline-none'
            />
            <div className='flex flex-row items-center rounded-full border border-[#0095D9] p-1 pl-4 pr-4'>
              <span className={"text- mr-2 text-[#0095D9]"}>Get</span>
              <img
                src={require("../../Assets/images/restart.png")}
                className='h-4 w-4'
              />
            </div>
          </div>
        </div> */}
        
        {/* Full Name */}
        <div className='mt-3 w-[90%] text-sm'>
          <label className='text-sm text-black'>Full Name *</label>
          <input
            type='text'
            placeholder='Full Name'
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
            className='mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-[#0095D9]'
          />
        </div>
        
        {/* Phone Number */}
        <div className='mt-3 w-[90%] text-sm'>
          <label className='text-sm text-black'>Phone Number *</label>
          <input
            type='tel'
            placeholder='Phone Number'
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            required
            className='mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-[#0095D9]'
          />
        </div>
        
        {/* Email */}
        <div className='mt-3 w-[90%] text-sm'>
          <label className='text-sm text-black'>Email</label>
          <input
            type='email'
            placeholder='Email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className='mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-[#0095D9]'
          />
        </div>
        
        {!titles && (
          <>
            {/* Doctor Selection Dropdown */}
            <div className='mt-3 flex w-[90%] flex-col gap-3'>
              <p className='text-sm text-black'>Assign Doctor *</p>
              {loadingDoctors ? (
                <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray'>
                  Loading doctors...
                </div>
              ) : (
                <Select
                  selectedPerson={selectedDoctor}
                  setSelectedPerson={setSelectedDoctor}
                  datas={doctorsList}
                >
                  <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                    {selectedDoctor?.name || "Select Doctor"} <BiChevronDown className='text-xl' />
                  </div>
                </Select>
              )}
            </div>
            
            {/* Gender */}
            <div className='mt-3 flex w-[90%] flex-col gap-3'>
              <p className='text-sm text-black'>Gender</p>
              <Select
                selectedPerson={gender}
                setSelectedPerson={setGender}
                datas={sortsDatas.genderFilter}
              >
                <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                  {gender?.name} <BiChevronDown className='text-xl' />
                </div>
              </Select>
            </div>
            
            {/* Aadhar ID */}
            <div className='mt-3 w-[90%] text-sm'>
              <label className='text-sm text-black'>Aadhar ID</label>
              <input
                type='text'
                placeholder='Aadhar ID'
                value={aadharId}
                onChange={(e) => setAadharId(e.target.value)}
                className='mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-[#0095D9]'
              />
            </div>
            
            {/* Blood Group */}
            {sortsDatas.bloodTypeFilter && (
              <div className='mt-3 flex w-[90%] flex-col gap-3'>
                <p className='text-sm text-black'>Blood Group</p>
                <Select
                  selectedPerson={bloodGroup}
                  setSelectedPerson={setBloodGroup}
                  datas={sortsDatas.bloodTypeFilter}
                >
                  <div className='flex-btn w-full rounded-lg border border-border p-4 text-sm font-light text-textGray focus:border focus:border-[#0095D9]'>
                    {bloodGroup?.name} <BiChevronDown className='text-xl' />
                  </div>
                </Select>
              </div>
            )}
            
            {/* Emergency Contact */}
            <div className='mt-3 w-[90%] text-sm'>
              <label className='text-sm text-black'>Emergency Contact</label>
              <input
                type='tel'
                placeholder='Emergency Contact'
                value={emergencyContact}
                onChange={(e) => setEmergencyContact(e.target.value)}
                className='mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-[#0095D9]'
              />
            </div>
            
            {/* Date of Birth */}
            <div className='mt-3 flex w-[90%] flex-col text-sm'>
              <label className='text-sm text-black'>Date of Birth</label>
              <DatePicker
                selected={date}
                onChange={(date) => setDate(date)}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy"
                className='mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-[#0095D9]'
              />
            </div>
            
            {/* Address */}
            <div className='mt-3 w-[90%] text-sm'>
              <label className='text-sm text-black'>Address</label>
              <input
                type='text'
                placeholder='Address'
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                className='mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-[#0095D9]'
              />
            </div>
            
            {/* Referred By */}
            <div className='mt-3 w-[90%] text-sm'>
              <label className='text-sm text-black'>Referred By</label>
              <input
                type='text'
                placeholder='Referred By'
                value={referredBy}
                onChange={(e) => setReferredBy(e.target.value)}
                className='mt-3 w-full rounded-lg border border-border bg-transparent p-4 text-sm font-light focus:border focus:border-[#0095D9]'
              />
            </div>
          </>
        )}
      </div>
      
      {/* Submit Buttons */}
      <div className='mt-6 grid w-full grid-cols-1 gap-4 sm:grid-cols-2'>
        <Button
          label={"Cancel"}
          backgroundColor={"#B8B8B8"}
          onClick={handleCancel}
          type="button"
        />
        <Button
          label={submitting ? "Adding..." : "Add Patient"}
          onClick={handleSubmit}
          loading={submitting}
          type="submit"
        />
      </div>
    </form>
  );
}

export default PersonalInfo;
